import { Controller } from "@hotwired/stimulus"
import { useDebounce } from "stimulus-use"

export default class extends Controller {
  static debounces = ['autosave']
  static values = { url: String }

  connect() {
    useDebounce(this, { wait: 300 })
  }

  onInput(event) {
    const form = event.target.form || event.target.closest('form')
    const method = form.method
    const url = this.urlValue || form.action

    if (url) {
      fetch(url, {
        method: method,
        body: new URLSearchParams(new FormData(form)),
        headers: {
          'Accept': "application/json",
          'X-Requested-With': "XMLHttpRequest",
          'X-CSRF-Token': getMetaValue("csrf-token")
        },
        credentials: "same-origin"
      })
    }
  }
}

function getMetaValue(name) {
  const element = document.head.querySelector(`meta[name="${name}"]`)
  if (element) {
    return element.getAttribute("content")
  }
}
